const choices = {
    autonomous: 'Autonome',
    dependent: 'Dépendant',
};

export default choices;
